<template>
  <div>
    <div class="login login_1st">
      <div class="login-wrap">
        <div class="login_id-pass">
          <div class="login_input-box login">
            <p class="login_cont-name">ログインＩＤ</p>
            <input
              type="text"
              id="name"
              name="ログインID"
              required=""
              minlength="4"
              maxlength="8"
              size="10"
              placeholder="EXAMPLE_ID"
              v-model="loginid"
            />
            <p class="login_cont-name">パスワード</p>
            <div class="login_pass-box">
              <input
                id="password"
                name="パスワード"
                required=""
                v-model="password"
                :type="pwdFlag ? 'password' : 'text'"
              />
              <button class="btn_passview">
                <img
                  src="@/assets/img/login/pass.png"
                  :class="[this.pwdFlag ? '' : 'img-opacity']"
                  @click="changePwd"
                  alt="非表示"
                />
              </button>
            </div>

            <p class="login_pass-lose">
              パスワードを忘れた方は
              <a @click="openForgotPwd" href="javascript:;">こちら</a>
            </p>
          </div>
          <van-button
            :disabled="this.loginid === '' || this.password === ''"
            block
            :color="
              this.loginid === '' || this.password === ''? '#AACBE7': '#3B82C4'"
            type="primary"
            native-type="submit"
            :loading="loading"
            @click="onClickLogin"
            id="login1_btn"
            >ログイン</van-button>
        </div>
      </div>
    </div>
    <div id="privacy-policy" v-show="privacyPolicyShow">
      <div class="privacy_inner">
        <div class="privacy_content">
          <p class="privacy_title">QuaLinkサービス利用規約</p>
          <p class="indent">イツモスマイルデジタルソリューションズ株式会社（以下「当社」といいます。）は、ビデオ通話アプリ「QuaLink」およびこれに関連する一切のサービス（以下総称して「本サービス」といいます。）の利用条件を、以下のとおりQuaLinkサービス利用規約（以下「本規約」といいます。）として定めます。</p>
          <p class="privacy_content-name">第1条（適用）</p>
          <p class="indent">1. 本規約は、本サービスの利用に関して、当社と契約者および利用ユーザとの間に適用されます。</p>
          <p class="indent">2. 当社が本サービスに関して当社ウェブサイト、料金表、申込書、個別契約、通知その他の方法により提示するルール、注意事項、ガイドライン、仕様、ポリシー等は、本規約の一部を構成するものとします。</p>
          <p class="indent">3. 本規約の内容と、前項の個別の定めの内容が異なる場合は、個別の定めが優先して適用されるものとします。ただし、当該個別の定めに別段の記載がある場合を除きます。</p>
          <p class="privacy_content-name">第2条（定義）</p>
          <p class="indent">本規約において使用する用語の意味は、次の各号に定めるとおりとします。</p>
          <p class="indent">(1) 「契約者」とは、本サービスの利用申込みを行い、当社または当社が認める代理店を通じて、当社から利用IDの発行その他利用開始の承諾を受けた法人または個人をいいます。</p>
          <p class="indent">(2) 「利用ユーザ」とは、契約者自身、ならびに契約者により招待、承認または利用を許諾され、本サービスを利用し、または本サービスの利用に必要なソフトウェアをインストールする者をいいます。</p>
          <p class="indent">(3) 「ユーザ」とは、契約者および利用ユーザを総称していいます。</p>
          <p class="indent">(4) 「本契約」とは、本規約に基づき当社と契約者との間で成立する本サービスの利用契約をいいます。</p>
          <p class="indent">(5) 「本ソフトウェア」とは、本サービスの利用に関連して当社が提供するアプリケーション、ソフトウェア、プログラム、アップデート、修正版その他一切のソフトウェアをいいます。</p>
          <p class="indent">(6) 「利用者データ」とは、ユーザが本サービスにおいて送信、保存、表示、共有、アップロードその他入力した情報、データ、音声、映像、画像、資料、テキストその他一切の情報をいいます。</p>
          <p class="indent">(7) 「当社ウェブサイト」とは、当社が運営するQuaLink公式サイト（https://qualink.jp）およびこれを承継または代替するウェブサイトをいいます。</p>
          <p class="indent">(8) 「代理店」とは、当社が本サービスの販売、請求、サポート等の全部または一部を委託または許諾した第三者をいいます。</p>
          <p class="privacy_content-name">第3条（本規約への同意および本契約の成立）</p>
          <p class="indent">1. 契約者は、本規約に同意のうえ、本サービスの利用申込みを行うものとします。</p>
          <p class="indent">2. 当社が契約者に対し、利用ID・パスワードの発行、利用開始通知その他当社所定の方法により申込みを承諾した時点で、本契約が成立するものとします。</p>
          <p class="indent">3. 利用ユーザは、本サービスにログインし、本サービスを利用し、または本ソフトウェアをインストールした時点で、本規約に同意したものとみなされます。</p>
          <p class="indent">4. 契約者が法人である場合、申込者は、当該法人を代表しまたは当該法人のために本契約を締結する正当な権限を有することを表明し、保証するものとします。</p>
          <p class="privacy_content-name">第4条（本サービスの内容）</p>
          <p class="indent">1. 本サービスの内容、機能、仕様、利用条件その他の詳細は、当社ウェブサイトまたは当社が別途指定する資料に定めるとおりとします。</p>
          <p class="indent">2. 当社は、当社が必要と判断する場合、本ソフトウェアまたは本サービスのアップデート、アップグレード、修正版等を提供することがあります。</p>
          <p class="indent">3. 前項の提供は、当社が別途定める場合を除き、契約者が契約中の本サービスの範囲内で行われるものとします。</p>
          <p class="privacy_content-name">第5条（ユーザ登録）</p>
          <p class="indent">1. 本サービスの利用には、当社所定の方法によるユーザ登録が必要となる場合があります。</p>
          <p class="indent">2. 契約者は、登録事項について、真実、正確かつ最新の情報を当社に提供するものとします。</p>
          <p class="indent">3. 契約者は、登録事項に変更が生じた場合、当社所定の方法により、速やかに変更内容を届け出るものとします。</p>
          <p class="indent">4. 当社は、登録事項に虚偽、誤記、記載漏れがあった場合、または契約者もしくは利用ユーザが本規約に違反するおそれがあると当社が合理的に判断した場合、登録を拒否し、または登録済みのID等を停止もしくは削除することができます。</p>
          <p class="privacy_content-name">第6条（ID・パスワードの管理）</p>
          <p class="indent">1. 契約者および利用ユーザは、自己の責任において、本サービスに関するIDおよびパスワードを適切に管理および保管するものとし、これを第三者に利用させ、貸与し、譲渡し、名義変更し、売買し、または担保に供してはならないものとします。</p>
          <p class="indent">2. IDまたはパスワードの管理不十分、使用上の過誤、第三者の不正使用等により生じた損害については、当社に故意または重過失がある場合を除き、当社は責任を負いません。</p>
          <p class="indent">3. 契約者または利用ユーザは、IDまたはパスワードの漏えい、盗用、不正使用またはそのおそれを認識した場合、直ちに当社に通知し、当社の指示に従うものとします。</p>
          <p class="indent">4. 当社は、当該ID・パスワードにより行われた一切の行為を、当該IDを保有する契約者または利用ユーザ本人の行為とみなすことができます。</p>
          <p class="privacy_content-name">第7条（利用環境）</p>
          <p class="indent">1. ユーザは、自己の責任と費用において、本サービスの利用に必要なPC、スマートフォン、タブレット、その他の対応端末、通信機器、通信回線、電力、ソフトウェアその他の利用環境を準備し、維持するものとします。</p>
          <p class="indent">2. 本サービスの利用にあたり、当社が動作確認済みとして案内する対応端末および推奨環境は、当社の判断により変更されることがあります。</p>
          <p class="indent">3. 利用環境、通信状況、端末性能、OS、ブラウザ、インストール済みソフトウェアその他の事情に起因して、本サービスの全部または一部が利用できない場合があることを、ユーザはあらかじめ承諾するものとします。</p>
          <p class="privacy_content-name">第8条（利用期間および自動更新）</p>
          <p class="indent">1. 本サービスの利用期間は、当社が契約者に利用ID・パスワードを通知し、または本サービスの利用を可能とした日（以下「利用開始日」といいます。）に開始し、契約者が選択したプランまたは当社と別途合意した個別条件に従って終了するものとします。</p>
          <p class="indent">2. 契約者は、申込みの際に、次のいずれかの契約期間を選択できるものとします。</p>
          <p class="indent">(1) 月間契約</p>
          <p class="indent">(2) 暦月単位の複数月契約（年間契約を含みます。）</p>
          <p class="indent">(3) 当社と別途合意するスポット契約</p>
          <p class="indent">3. 各契約期間の満了日は、申込書、注文書、個別契約、料金表または当社が別途通知する条件に従うものとします。</p>
          <p class="indent">4. 契約者から、契約期間満了日の2か月前までに、当社または代理店所定の方法により解約の通知が到達しない場合、本契約は、月間契約にあっては1か月間、複数月契約にあっては更新前と同一の期間、同一条件で自動的に更新されるものとし、以後も同様とします。</p>
          <p class="indent">5. 前項の更新条件については、契約者が十分に確認のうえ申し込むものとします。</p>
          <p class="privacy_content-name">第9条（利用料金および支払方法）</p>
          <p class="indent">1. 契約者は、本サービスの利用の対価として、当社または代理店が別途定める利用料金、初期費用、オプション料金その他の費用を、所定の支払条件に従って支払うものとします。</p>
          <p class="indent">2. 振込手数料その他支払に要する費用は、契約者の負担とします。</p>
          <p class="indent">3. 契約者が支払期限までに利用料金等を支払わない場合、契約者は、支払期日の翌日から完済に至るまで、年14.6％の割合による遅延損害金を支払うものとします。</p>
          <p class="indent">4. 当社または代理店が受領した利用料金等は、法令上返金が義務付けられる場合または当社が別途明示的に認める場合を除き、返金されないものとします。</p>
          <p class="privacy_content-name">第10条（本サービスの変更）</p>
          <p class="indent">1. 当社は、法令の改正、セキュリティ上の必要、運営上の必要、機能改善、第三者サービスの仕様変更、その他相当の事由がある場合、本サービスの内容、仕様、デザイン、URL、提供方法その他の事項を変更することができます。</p>
          <p class="indent">2. 当社は、前項の変更がユーザに重大な影響を及ぼす場合、合理的な方法により事前に周知するよう努めます。</p>
          <p class="indent">3. 第1項の変更によりユーザに損害が生じた場合であっても、当社に故意または重過失がある場合を除き、当社は責任を負いません。</p>
          <p class="privacy_content-name">第11条（本サービスの中断・停止）</p>
          <p class="indent">1. 当社は、次の各号のいずれかに該当する場合、本サービスの全部または一部を中断または停止することができます。</p>
          <p class="indent">(1) 保守点検、設備更新、障害対応、セキュリティ対応を行う場合</p>
          <p class="indent">(2) 通信回線、電力供給、クラウド基盤、データセンターその他の外部インフラに障害が生じた場合</p>
          <p class="indent">(3) 火災、停電、地震、感染症拡大、サイバー攻撃その他の不可抗力が生じた場合</p>
          <p class="indent">(4) その他、当社が運営上または技術上やむを得ないと合理的に判断した場合</p>
          <p class="indent">2. 当社は、計画メンテナンスを行う場合、緊急時を除き、合理的な方法により事前に周知するよう努めます。</p>
          <p class="indent">3. 当社は、本条に基づく中断または停止によりユーザに生じた損害について、当社に故意または重過失がある場合を除き、責任を負いません。</p>
          <p class="privacy_content-name">第12条（契約者の責任および招待ユーザの管理）</p>
          <p class="indent">1. 契約者は、自らが招待し、承認し、または利用を許諾した利用ユーザに本規約を遵守させるものとし、当該利用ユーザによる本サービスの利用について責任を負うものとします。</p>
          <p class="indent">2. 契約者は、利用ユーザに付与する権限、利用範囲、アカウント数等を自己の責任において管理するものとします。</p>
          <p class="indent">3. 契約者は、退職、異動、委託終了その他の理由により利用の必要がなくなった利用ユーザについて、速やかにアクセス権限の停止または削除を行うものとします。</p>
          <p class="indent">4. 契約者または利用ユーザが本規約に違反したことにより当社または第三者に損害が生じた場合、契約者は、当該損害について責任を負うものとします。</p>
          <p class="privacy_content-name">第13条（禁止事項）</p>
          <p class="indent">ユーザは、本サービスの利用にあたり、次の各号のいずれかに該当する行為または該当すると当社が合理的に判断する行為を行ってはならないものとします。</p>
          <p class="indent">(1) 法令、公序良俗または本規約に違反する行為</p>
          <p class="indent">(2) 犯罪行為に関連する行為またはこれを助長する行為</p>
          <p class="indent">(3) 当社、他のユーザまたは第三者の知的財産権、肖像権、名誉、信用、プライバシー、パブリシティ権その他の権利利益を侵害する行為</p>
          <p class="indent">(4) 他人を誹謗中傷し、差別し、脅迫し、または嫌がらせを行う行為</p>
          <p class="indent">(5) わいせつ、暴力的、残虐、差別的または未成年者に有害な情報を送信、表示、共有または保存する行為</p>
          <p class="indent">(6) 他人になりすます行為、虚偽の情報を登録または送信する行為</p>
          <p class="indent">(7) コンピュータウイルス、マルウェア、不正コード、過度な負荷を与えるプログラムその他有害なデータを送信、掲載、アップロードまたは配布する行為</p>
          <p class="indent">(8) 本サービスまたはこれに接続するサーバ、ネットワーク、ソフトウェア、システムの機能を妨害、破壊、改ざん、解析または制限する行為</p>
          <p class="indent">(9) リバースエンジニアリング、逆アセンブル、逆コンパイル、ソースコード解析その他本ソフトウェアまたは本サービスの解析行為</p>
          <p class="indent">(10) 本サービスを複製、改変、翻案し、譲渡し、再許諾し、転売し、または商業的に再利用する行為</p>
          <p class="indent">(11) 当社が認める場合を除き、本サービスの全部または一部を第三者に再販売、再提供または転用する行為</p>
          <p class="indent">(12) 他のユーザの個人情報または利用者データを不当に収集、蓄積または利用する行為</p>
          <p class="indent">(13) 本サービス上の認証情報、アクセス制御、利用制限またはセキュリティ機構を回避する行為</p>
          <p class="indent">(14) 本サービスの運営を妨害し、または当社の信用を毀損する行為</p>
          <p class="indent">(15) 居住国、利用国またはデータ送受信先の国・地域において適用される法令に違反する行為</p>
          <p class="indent">(16) 反社会的勢力に対する利益供与その他これに協力する行為</p>
          <p class="indent">(17) 当社、他のユーザまたは第三者に経済的損害または精神的損害を与える行為</p>
          <p class="indent">(18) その他、当社が不適切と合理的に判断する行為</p>
          <p class="privacy_content-name">第14条（録音、録画、画面共有等）</p>
          <p class="indent">1. ユーザは、本サービスを通じて録音、録画、画面キャプチャ、画面共有、配信、保存または第三者提供を行う場合、相手方その他必要な権利者の同意を、自己の責任と費用において取得するものとします。</p>
          <p class="indent">2. ユーザは、利用者データについて、適法に利用し、送信し、保存し、共有し、または第三者に提供する権限を有することを保証するものとします。</p>
          <p class="indent">3. 当社は、法令上または運営上必要な場合を除き、通話内容、音声、映像その他利用者データを常時監視する義務を負いません。</p>
          <p class="indent">4. ユーザが前各項に違反したことにより第三者との間で紛争が生じた場合、当該ユーザは自己の責任と費用でこれを解決するものとします。</p>
          <p class="privacy_content-name">第15条（利用者情報および個人情報の取扱い）</p>
          <p class="indent">1. 当社によるユーザの個人情報その他利用者情報の取扱いは、別途当社が定めるプライバシーポリシーに従うものとし、ユーザはこれに同意するものとします。</p>
          <p class="indent">2. 当社は、本人確認、アカウント管理、請求・決済、サポート対応、障害対応、セキュリティ確保、不正利用防止、サービス改善、利用状況分析、重要なお知らせの送信その他プライバシーポリシーに定める目的のために、利用者情報を取り扱うことがあります。</p>
          <p class="indent">3. 契約者は、利用ユーザに関する個人情報を当社に提供する場合、法令に従い必要な同意取得その他適法な手続を行うものとします。</p>
          <p class="privacy_content-name">第16条（利用者データ）</p>
          <p class="indent">1. 利用者データの権利は、当社に移転するものではなく、当該データを適法に保有するユーザまたは権利者に留保されます。</p>
          <p class="indent">2. ユーザは、当社に対し、本サービスの提供、保守、障害対応、サポート、セキュリティ確保、不正利用防止、バックアップ、統計分析および本サービスの改善に必要な範囲で、利用者データを使用、複製、保存、解析、表示、送信その他利用することを許諾するものとします。</p>
          <p class="indent">3. 当社は、利用者データについて、法令上保存義務がある場合または当社の責に帰すべき事由によらない障害復旧のため合理的に必要な場合を除き、契約終了後に継続して保管する義務を負わないものとします。</p>
          <p class="indent">4. 当社は、契約終了後、法令上必要な保存期間または合理的なバックアップ保有期間の経過後、利用者データを削除することができます。</p>
          <p class="privacy_content-name">第17条（知的財産権）</p>
          <p class="indent">1. 本サービス、本ソフトウェア、当社ウェブサイト、マニュアル、画面デザイン、ロゴ、商標、コンテンツ、プログラム、データベースその他本サービスに関する一切の知的財産権は、当社または当社にライセンスを許諾した者に帰属します。</p>
          <p class="indent">2. 当社は、契約者に対し、本契約の有効期間中、本規約および個別条件に従って本サービスおよび本ソフトウェアを利用するための、非独占的、譲渡不能、再許諾不可、取消可能な利用権を付与します。</p>
          <p class="indent">3. ユーザは、当社の事前の書面による承諾なく、本サービスまたは本ソフトウェアを複製、改変、翻案、公開、送信、頒布、譲渡、貸与、再利用、再許諾その他当社の権利を侵害する態様で利用してはならないものとします。</p>
          <p class="indent">4. ユーザが本条に違反した場合、当社は、当該違反行為の差止めを求め、これにより当社に生じた損害（合理的な弁護士費用を含みます。）の賠償を請求することができます。</p>
          <p class="privacy_content-name">第18条（データの削除および開示）</p>
          <p class="indent">1. 当社は、利用者データを事前に監視または検閲する義務を負いません。</p>
          <p class="indent">2. 当社は、次の各号のいずれかに該当すると合理的に判断した場合、事前通知なく、利用者データを削除し、非表示とし、アクセスを制限し、または掲載場所を変更することができます。</p>
          <p class="indent">(1) 本規約に違反する場合またはそのおそれがある場合</p>
          <p class="indent">(2) 法令または公的機関の要請に対応する必要がある場合</p>
          <p class="indent">(3) 当社、他のユーザまたは第三者の権利利益、生命、身体、財産、名誉、信用または安全を保護するため必要がある場合</p>
          <p class="indent">(4) 本サービスの安定運用またはセキュリティ確保のため必要がある場合</p>
          <p class="indent">3. 当社は、法令に基づく場合、裁判所、行政機関その他権限ある機関の命令または要請がある場合、または前項各号に定める目的のため必要がある場合、利用者データを保存し、開示することができます。</p>
          <p class="privacy_content-name">第19条（ユーザによる解約）</p>
          <p class="indent">1. 契約者は、当社または代理店所定の方法により、契約期間満了日の2か月前までに通知することで、本契約を期間満了日をもって解約することができます。</p>
          <p class="indent">2. 契約者による中途解約が認められる場合であっても、別段の定めがある場合を除き、契約者は既に発生した利用料金等の支払義務を免れず、当社または代理店が受領済みの利用料金等は返金されません。</p>
          <p class="indent">3. 解約日にかかわらず、契約期間満了日までの利用料金等は発生するものとし、日割計算による返金は行われないものとします。</p>
          <p class="privacy_content-name">第20条（当社による利用停止、解除等）</p>
          <p class="indent">1. 当社は、契約者または利用ユーザが次の各号のいずれかに該当する場合、事前に催告することなく、本サービスの全部または一部の利用を停止し、ID・パスワードを無効化し、利用者データを削除し、または本契約を解除することができます。</p>
          <p class="indent">(1) 本規約または個別条件に違反した場合</p>
          <p class="indent">(2) 料金その他の支払債務の履行を遅滞した場合</p>
          <p class="indent">(3) 登録事項に虚偽、重大な誤記または記載漏れがあった場合</p>
          <p class="indent">(4) 破産、民事再生、会社更生、特別清算その他これらに準ずる手続の申立てがあった場合</p>
          <p class="indent">(5) 差押え、仮差押え、仮処分、強制執行、租税滞納処分その他信用不安を生じさせる事由が生じた場合</p>
          <p class="indent">(6) 本サービスの運営、セキュリティまたは他のユーザの保護のため必要がある場合</p>
          <p class="indent">(7) 反社会的勢力に該当し、またはこれと関与していることが判明した場合</p>
          <p class="indent">(8) その他、当社と契約者との信頼関係を維持しがたい重大な事由がある場合</p>
          <p class="indent">2. 前項に基づく措置により契約者または利用ユーザに損害が生じた場合であっても、当社に故意または重過失がある場合を除き、当社は責任を負いません。</p>
          <p class="indent">3. 第1項に基づき本契約が解除された場合、契約者は、期限の利益を喪失し、当社または代理店に対する一切の債務を直ちに履行するものとします。</p>
          <p class="privacy_content-name">第21条（本サービスの終了および事業譲渡）</p>
          <p class="indent">1. 当社は、事業上の都合その他相当の事由により、本サービスの全部または一部の提供を終了することがあります。</p>
          <p class="indent">2. 当社は、本サービスの全部を終了する場合、原則として2か月前までに契約者に通知するよう努めます。</p>
          <p class="indent">3. 当社が本サービスに関する事業を第三者に譲渡し、承継させ、または会社分割、合併その他の組織再編を行う場合、当社は、本契約上の地位、本規約に基づく権利義務および利用者情報を、当該譲受人または承継人に移転させることができるものとし、契約者はあらかじめこれに同意するものとします。</p>
          <p class="privacy_content-name">第22条（保証の否認）</p>
          <p class="indent">1. 当社は、本サービスおよび本ソフトウェアについて、完全性、正確性、継続性、可用性、安全性、特定目的適合性、有用性、第三者権利非侵害、利用結果の正確性、通信品質または表示品質を保証するものではありません。</p>
          <p class="indent">2. 当社は、本サービスにバグ、障害、セキュリティ上の欠陥その他の不具合が存在しないことを保証するものではありません。</p>
          <p class="indent">3. 当社は、ユーザが本サービスを利用して取得した情報、助言、資料その他一切の情報について、その真実性、正確性、適法性または有用性を保証するものではありません。</p>
          <p class="privacy_content-name">第23条（損害賠償および責任制限）</p>
          <p class="indent">1. ユーザは、本サービスの利用に関連して、他のユーザまたは第三者との間で紛争が生じた場合、自己の責任と費用においてこれを解決するものとします。</p>
          <p class="indent">2. ユーザが本規約に違反し、または自己の責めに帰すべき事由により、当社または代理店に損害を与えた場合、当該ユーザおよび契約者は、当社または代理店に生じた一切の損害（合理的な弁護士費用を含みます。）を賠償するものとします。</p>
          <p class="indent">3. 当社または代理店は、当社に故意または重過失がある場合を除き、本サービスの提供の遅延、中断、停止、変更、終了、データ消失、漏えい、不正アクセス、端末障害、通信障害その他本サービスに関連してユーザに生じた損害について責任を負いません。</p>
          <p class="indent">4. 当社がユーザに対して損害賠償責任を負う場合であっても、その責任は、通常かつ直接の損害に限られるものとし、逸失利益、間接損害、特別損害、拡大損害、結果損害、データ復旧費用その他これらに類する損害については責任を負わないものとします。</p>
          <p class="indent">5. 当社がユーザに対して負う損害賠償額の総額は、当該損害発生日の前12か月間に、当該契約者が当社または代理店に現実に支払った本サービス利用料金の総額を上限とします。ただし、利用期間が12か月に満たない場合は、当該利用期間中に現実に支払った総額を上限とします。</p>
          <p class="indent">6. 本契約が消費者契約法第2条第3項に定める消費者契約に該当する場合、本条その他本規約のうち、当社または代理店の損害賠償責任を全部免除し、または消費者契約法その他の強行法規に反して消費者の権利を制限しもしくは義務を加重する部分は、その限度で適用されないものとします。</p>
          <p class="privacy_content-name">第24条（不可抗力）</p>
          <p class="indent">当社は、戦争、内乱、暴動、騒乱、テロ行為、感染症、自然災害、火災、停電、通信障害、クラウド基盤障害、サイバー攻撃、法令の制定改廃、公権力による命令処分、輸送停止、労働争議その他当社の合理的支配を超える事由により、本サービスの全部または一部の履行遅滞または履行不能が生じた場合、その責任を負わないものとします。</p>
          <p class="privacy_content-name">第25条（反社会的勢力の排除）</p>
          <p class="indent">1. 契約者および利用ユーザは、現在および将来にわたり、次の各号のいずれにも該当しないことを表明し、保証するものとします。</p>
          <p class="indent">(1) 暴力団、暴力団員、暴力団準構成員、暴力団関係企業、総会屋、社会運動標榜ゴロ、特殊知能暴力集団その他これらに準ずる者（以下総称して「反社会的勢力」といいます。）であること</p>
          <p class="indent">(2) 反社会的勢力が経営を支配し、または実質的に関与していること</p>
          <p class="indent">(3) 反社会的勢力を利用し、または資金提供その他の利益供与を行うこと</p>
          <p class="indent">(4) 暴力的要求行為、法的責任を超えた不当要求行為、脅迫的言動、暴力行為、風説流布、偽計、威力業務妨害その他これらに準ずる行為を行うこと</p>
          <p class="indent">2. 契約者または利用ユーザが前項に違反した場合、当社は、何らの催告を要せず、直ちに本サービスの利用停止または本契約の解除をすることができます。</p>
          <p class="indent">3. 前項に基づく解除により契約者または利用ユーザに損害が生じた場合であっても、当社は責任を負いません。</p>
          <p class="privacy_content-name">第26条（本規約の変更）</p>
          <p class="indent">1. 当社は、次の各号のいずれかに該当する場合、本規約を変更することがあります。</p>
          <p class="indent">(1) 本規約の変更が、ユーザの一般の利益に適合するとき</p>
          <p class="indent">(2) 本規約の変更が、本契約の目的に反せず、かつ、変更の必要性、変更後の内容の相当性、変更内容その他の事情に照らして合理的なものであるとき</p>
          <p class="indent">2. 当社は、本規約を変更する場合、変更後の本規約の内容および効力発生日を、当社ウェブサイトへの掲載、電子メールその他当社が適切と判断する方法により、効力発生日までに周知します。</p>
          <p class="indent">3. 変更後にユーザが本サービスを利用した場合、当該ユーザは変更後の本規約に同意したものとみなされます。</p>
          <p class="privacy_content-name">第27条（通知または連絡）</p>
          <p class="indent">1. 当社から契約者または利用ユーザに対する通知または連絡は、電子メール、当社ウェブサイトへの掲示、本サービス上の表示、郵送その他当社が適当と判断する方法により行います。</p>
          <p class="indent">2. 前項の通知または連絡は、当社が発信し、掲載し、または発送した時点で、その効力を生じるものとします。ただし、法令上別段の定めがある場合を除きます。</p>
          <p class="indent">3. 契約者または利用ユーザから当社に対する通知または連絡は、当社所定の窓口宛てに、当社所定の方法により行うものとします。</p>
          <p class="privacy_content-name">第28条（契約上の地位の譲渡等の禁止）</p>
          <p class="indent">契約者および利用ユーザは、当社の事前の書面による承諾なく、本契約上の地位または本規約に基づく権利もしくは義務を、第三者に譲渡し、承継させ、担保に供し、またはその他処分してはならないものとします。</p>
          <p class="privacy_content-name">第29条（分離可能性）</p>
          <p class="indent">本規約のいずれかの条項またはその一部が、法令等により無効または執行不能と判断された場合であっても、本規約のその他の条項および無効または執行不能と判断された部分以外の部分は、引き続き完全に効力を有するものとします。</p>
          <p class="privacy_content-name">第30条（存続条項）</p>
          <p class="indent">本契約終了後も、第14条、第15条、第16条、第17条、第18条、第23条、第24条、第25条、第28条、第29条、第31条、第32条およびその性質上存続すべき条項は、有効に存続するものとします。</p>
          <p class="privacy_content-name">第31条（準拠法）</p>
          <p class="indent">本規約および本契約の成立、効力、履行ならびに解釈に関しては、日本法を準拠法とします。</p>
          <p class="privacy_content-name">第32条（合意管轄）</p>
          <p class="indent">本サービスまたは本規約に関連して、当社と契約者または利用ユーザとの間に生じた一切の紛争については、福岡地方裁判所または福岡簡易裁判所を第一審の専属的合意管轄裁判所とします。</p>
          <p class="privacy_content-name">第33条（日本語版の優先）</p>
          <p class="indent">本規約に多言語版が存在する場合であって、日本語版とその他の言語版との間に矛盾抵触があるときは、日本語版が優先して適用されるものとします。</p>
          <p class="privacy_content-name">第34条（お問い合わせ窓口）</p>
          <p class="indent">本規約に関するお問い合わせは、以下の窓口までご連絡ください。</p>
          <p class="privacy_content-name">お問い合わせ窓口</p>
          <p class="indent">イツモスマイルデジタルソリューションズ株式会社</p>
          <p class="indent">〒770-0022</p>
          <p class="indent">徳島県徳島市佐古二番町5-17</p>
          <p class="indent">電話番号：088-677-8866</p>
          <p class="indent">受付時間：平日10時から17時まで</p>
          <p class="indent">E-mail：info@itsumo-app.jp</p>
          <p class="privacy_content-name">附則</p>
          <p class="privacy_content-date">最終改定日：2026年4月1日</p>
          <p class="privacy_content-agree">
            内容に同意されましたら、<br />
            下記の「同意する」ボタンを押してください。
          </p>
        </div>
        <div class="tsunagaru_usage_read">
          <van-checkbox v-model="tsunagaru_usage_read_checked" style="margin-top: 10px;">次回から表示しない</van-checkbox>
        </div>
        <div
          @click="clickAgree"
          id="agree_btn"
          :class="{ possible: confirmDisable }"
        >
          同意する
        </div>
      </div>
    </div>
    <van-dialog
      v-model:show="showCodeErrorDialog"
      :message="codeErrorMsg"
      show-cancel-button
    >
    </van-dialog>
  </div>
</template>

<script>
  import {CheckCode, CheckLoginRequest, GetRefreshToken, Login} from "@/services/login";
  import {setAuthorization} from "@/utils/request";
  import {Toast} from "vant";
  import "vant/es/toast/style";
  import "vant/es/dialog/style";

  export default {
  components: {},
  data() {
    return {
      //user数据
      loginid: "",
      password: "",
      loading: false,
      //code错误与提示信息
      codeError: false,
      showCodeErrorDialog: false,
      codeErrorMsg: "番号が間違っています。URLを確認してください",
      pwdFlag: true,
      privacyPolicyShow: true,
      confirmDisable: false,
      code: "",
      login_request_interval:null,
      login_request_last:true,
      // 获取uuid用
      deviceFlg:false,
      deviceInterval:null,
      // 底部checkbox用
      tsunagaru_usage_read_checked:false,
    };
  },
  created() {},
  mounted() {
    this.errorLogOut();

    // const code = this.$route.query.code;
    let code = this.$route.query.code;
    if(typeof code==='undefined' || code==='' || code===null){
      code='12345'
    }
    if (code && code != "" && code != undefined) {
      CheckCode({ code: code }).then((res) => {
        if (res.data.code >= 0) {
          this.code = code;
          localStorage.removeItem(process.env.VUE_APP_CODE_KEY);
          localStorage.setItem(process.env.VUE_APP_CODE_KEY, this.code);
          this.codeError = false;
          this.showCodeErrorDialog = false;
        } else {
          this.codeError = true;
          this.showCodeErrorDialog = true;
        }
      });
    } else {
      this.codeError = true;
      this.showCodeErrorDialog = true;
    }
    const target = document.querySelector(".privacy_content");
    target.addEventListener("scroll", this.roll);

    let tsunagaru_usage_read = localStorage.getItem("tsunagaru_usage_read");
    console.log(tsunagaru_usage_read);
    if(tsunagaru_usage_read == 'true'){
      this.privacyPolicyShow = false;
    }

    this.adjustMarginTop();
    window.addEventListener('resize', this.adjustMarginTop);
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.adjustMarginTop);
  },
  methods: {
    adjustMarginTop() {
      let height = window.innerHeight;
      let loginInputBox = this.$el.querySelector('.login_input-box');
      let loginIdPass = this.$el.querySelector('.login_id-pass');
      if (height < 500 ) {
        loginInputBox.style.marginTop = height / 10 + 'px';
        loginIdPass.style.padding = "0 17px 20px"
      } else {
        loginInputBox.style.marginTop = '155px';
        loginIdPass.style.padding = "0 17px 58px"
      }
    },
    async errorLogOut(){
      // 登录异常退出重新登录处理
      let num=0;
      this.deviceInterval = setInterval(async () => {
        num++
        if(num>10){
          if(this.deviceInterval){
            clearInterval(this.deviceInterval);
          }
          return;
        }
        // 只执行一次 且在获取到uuid后
        if(!this.deviceFlg && typeof device !== 'undefined' && device.uuid !== null && typeof device.uuid !== 'undefined'){
          if(this.deviceInterval){
            clearInterval(this.deviceInterval);
          }
          // 根据uuid获取状态
          let ret = await GetRefreshToken({ "uuid": device.uuid });
          // uuid有效
          if ( ret && ret.data && ret.data.data && ret.data.data.status && ret.data.data.status == 'effective') {
            localStorage.setItem("refreshtoken", ret.data.data.refreshtoken);
            localStorage.setItem(process.env.VUE_APP_USER_KEY, JSON.stringify(ret.data.data.user));
            let expireAt_T = ret.data.data.expireAt.replace(' ', 'T');
            setAuthorization({ token: ret.data.data.token, expireAt: new Date(expireAt_T) });
            window.location.reload();
          }
        }
      }, 500);
    },
    roll() {
      const target = document.querySelector(".privacy_content");
      var scroll_y = target.scrollHeight;
      var scroll_ny = target.offsetHeight;
      var scroll_p = target.scrollTop;
      if (scroll_y - scroll_p - scroll_ny < 1) {
        this.confirmDisable = true;
      }
    },
    onClickLogin() {
      if (this.codeError) {
        this.showCodeErrorDialog = true;
        return;
      }
      this.loading = true;
      this.showLoading();
      Login({
        loginid: this.loginid,
        password: this.password,
        code: this.code,
      }).then(this.afterLogin);
    },
    async afterLogin(res) {
      this.loading = false;
      this.$toast.clear();
      this.loginRes = {};
      const loginRes = res.data;
      if (loginRes.code >= 0) {
        // code == 1:二段验证
        if (loginRes.code === 1) {
          this.loginRes = loginRes;
          localStorage.setItem("loginAuthoritarian", JSON.stringify(loginRes));
          this.$router.push({path: "/verification",});
          this.$store.commit("setLoginid", this.loginid);
          this.$store.commit("setPassword", this.password);
          this.$store.commit("setCode", this.code);
        }else if (loginRes.code === 2) {
          // code == 2 帐号已经有人登录 请求登录
          Toast.loading({
            duration: 0,
            forbidClick: true,
          });
          this.login_request_interval = setInterval(()=>{this.applyLogin(loginRes);
          }, 1000);
        }else {
          this.toMain(loginRes);
        }
      } else {
        this.error = loginRes.message;
        Toast(this.error);
      }
    },
    async applyLogin(loginRes){
      if(!this.login_request_last){
        return;
      }
      this.login_request_last = false;
      let ret = loginRes.data;
      // 发送请求验证对方是否同意请求
      let res =  await CheckLoginRequest({status:"apply",id:ret.id,uid:ret.uid});
      if(res.data.code >= 0){
        let result = res.data.data;
        if(result.status == 'outTime'){
          // 本次申请已经超时
          this.clearLoading();
          Toast.fail(result.message);
        }else if(result.status == 'agree'){
          // 同意
          this.clearLoading();
          this.onClickLogin();
        }else if(result.status == 'refuse') {
          // 拒绝
          this.clearLoading();
          Toast.fail(result.message);
        }else if(result.status == 'exist') {
          // 有其他用户在登录
          this.clearLoading();
          Toast.fail(result.message);
        }
      }else{
        Toast("error");
      }
      this.login_request_last = true;
    },
    clearLoading(){
      clearInterval(this.login_request_interval);
      this.login_request_interval = null;
      Toast.clear();
    },
    toMain(data) {
      //用户名密码验证通过之后，保存用户信息 跳转主页
      const { user, refreshToken, token, expireAt } = data.data;
      localStorage.setItem("refreshtoken", refreshToken);
      localStorage.setItem(process.env.VUE_APP_USER_KEY, JSON.stringify(user));
      //解决ipad 登录问题
      let expireAt_T = expireAt.replace(' ', 'T');

      setAuthorization({ token: token, expireAt: new Date(expireAt_T) });

      // 检查 sessionStorage 中是否有会议URL
      const redirectUrl = sessionStorage.getItem('redirectUrl');
      console.log("--------"+redirectUrl+"--------")

      if (redirectUrl) {
        // 如果有，重定向到这个URL，并删除 sessionStorage 中的记录
        this.$router.push(redirectUrl);
        sessionStorage.removeItem('redirectUrl');
      } else {
        // 如果没有，那么进行默认的页面刷新操作
        window.location.reload();
      }
    },
    showLoading() {
      this.$toast.loading({
        mask: true,
        message: "",
      });
    },
    changePwd() {
      this.pwdFlag = !this.pwdFlag;
    },
    clickAgree() {
      this.privacyPolicyShow = false;
      if(this.tsunagaru_usage_read_checked){
        localStorage.setItem("tsunagaru_usage_read",true);
      }
    },
    openAgree() {
      this.privacyPolicyShow = true;
    },
    openForgotPwd() {
      this.$router.push({
        path: "/verifyUserLoginId",
        query: { code: this.code },
      });
    },
  },

  watch: {},
};
</script>

<style scoped>
#login1_btn {
  width: 100%;
  height: 54px;
  background: #aacbe7;
  border-radius: 8px;
  color: #fff;
  display: block;
  font-size: 20px;
  line-height: 54px;
  text-align: center;
  margin-top: auto;
}
.img-opacity {
  opacity: 0.4;
}
#name:focus,
#password:focus {
  border: 2px solid #e59700;
}
.indent {
  text-indent: 1em;
}
.tsunagaru_usage_read{
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>